module.exports = __webpack_public_path__ + "static/img/train_list.a1f87de8.png";